import { ElementRef } from '@angular/core';
import { DropdownMenuComponent } from './dropdown-menu.component';
var DropdownTogglerDirective = /** @class */ (function () {
    function DropdownTogglerDirective(togglerElement) {
        this.togglerElement = togglerElement;
        this.dropdownOpened = false;
    }
    Object.defineProperty(DropdownTogglerDirective.prototype, "dropdown", {
        set: function (dropdownElement) {
            this.dropdownElement = dropdownElement;
            this.dropdownOpened = this.dropdownElement.dropdownOpened;
        },
        enumerable: true,
        configurable: true
    });
    DropdownTogglerDirective.prototype.onClick = function ($event) {
        if (!this.dropdownOpened && ($event.target === this.togglerElement.nativeElement ||
            this.togglerElement.nativeElement.contains($event.target))) {
            this.toggleDropdown(true);
        }
        else if (this.dropdownOpened &&
            (!this.dropdownElement.elRef.nativeElement.querySelector('[keepMenuOpenItem]') ||
                !this.dropdownElement.elRef.nativeElement.querySelector('[keepMenuOpenItem]').contains($event.target))) {
            this.toggleDropdown(false);
        }
    };
    DropdownTogglerDirective.prototype.toggleDropdown = function (value) {
        this.dropdownOpened = value;
        this.dropdownElement.toggleDropdown(value);
    };
    return DropdownTogglerDirective;
}());
export { DropdownTogglerDirective };
